import { ReactElement } from 'react';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import '../../../../theme/swiper.css';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import '../index.less';

if (SpringConfigs.IS_RTL) {
  import('./../rtl.less');
}

export const HeaderArrowsSkeleton = (): ReactElement => {
  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}
    >
      <Skeleton.Input
        style={{
          minWidth: 100,
          width: 100,
          height: 14,
          borderRadius: 4
        }}
        active
      />
      <div style={{ display: 'flex', gap: 12 }}>
        <Skeleton.Button
          style={{
            height: 32,
            width: 32,
            minWidth: 32,
            borderRadius: 50
          }}
          active
        />
        <Skeleton.Button
          style={{
            height: 32,
            width: 32,
            minWidth: 32,
            borderRadius: 50
          }}
          active
        />
      </div>
    </div>
  );
};
